import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function Blogsforhome() {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const response = await axios.get("https://harasky.com/api/user/api.php");
            setBlogs(response.data);
        } catch (error) {
            console.error("Error fetching blogs:", error);
        }
    };

    return (
        <section className="sermainBG" id="Blogs">
            <div className="container">
                <div className="row">
                    {blogs.slice(0, 3).map((blog) => (
                        <div className="col-md-4" key={blog.id}>
                            <Link to={`/blog/${blog.slugurl}`} className="text-decoration-none">
                                <div className="blogMain">
                                    <div className="blogImg">
                                        <img 
                                            src={`https://harasky.com/api/uploads/${blog.bimg}`} 
                                            alt={blog.btitle} 
                                        />
                                    </div>
                                    <div className="blogtext">
                                        <span>{new Date(blog.bdate).toLocaleDateString()}</span>
                                        <p>{blog.btitle}</p>
                                        <span className="read-more">Read More</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>

                {blogs.length > 3 && (
                    <div className="row mb-5">
                        <div className="col-md-12">
                            <div className="headingTextBox mt-5">
                                <Link style={{textDecoration:'none'}} to={'Allblogs'} className="customBtn2">See More</Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
